import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose, withProps } from "recompose";
import { initiatePairing } from "src/modules/pairing-requester/duck/epics";
import { withPairingRequester } from "src/modules/pairing-requester/PairingRequester";
import { getDevicesToPair } from "src/modules/device/duck/selectors";
import { pairingSources } from "src/modules/pairing/constants";
import withRouter from "src/routing/withRouter";
import NearbyDevices from "./NearbyDevices";

function mapStateToProps(state) {
  return {
    devices: getDevicesToPair(state)
  };
}

function mapDispatchToProps(dispatch, { pairingRequester, flow }) {
  const { sendRequestMessage } = pairingRequester;
  return {
    initiatePairing: (responder) => {
      dispatch(
        initiatePairing({
          responder,
          sendRequestMessage,
          flow,
          pairingSource: pairingSources.AUTO_PAIRING
        })
      );
    }
  };
}

const enhance = compose(
  withPairingRequester,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({ flow, closeWizard, router }) => {
    return {
      onBack: router.location.pathname === "/welcome" ? closeWizard : null,
      onClose: closeWizard,
      openManualPairing: () => {
        flow.push("manual-pairing");
      }
    };
  }),
  withTranslation()
);

export default enhance(NearbyDevices);
